module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('map-loader', {
    attrs: {
      "map-config": _vm.mapConfig,
      "apiKey": "AIzaSyCrtvovqd2wcsQ2kmd3RSjN9yJq1vun5eA"
    }
  }, [_vm._l((_vm.markers), function(marker) {
    return [_c('child-marker', {
      key: marker.id,
      attrs: {
        "position": marker.position
      }
    })]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da43e648"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/util/MyMap.vue
// module id = 1469
// module chunks = 0